import React, { useState, useEffect } from "react";
import LineColumnArea from "./LineColumnArea";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import Chart from "react-apexcharts"; // Add this import

const OverView = ({ partsDataMap, selectedDate, selectedShift,selectedMachine,selectedChildPart }) => {

  const [selectedTimeRange, setSelectedTimeRange] = useState("All");
  const [filteredData, setFilteredData] = useState(partsDataMap);
  const [isLoading, setIsLoading] = useState(false);
  // Add state for chart options and series
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
const isToday = (dateStr) => {
  const today = new Date();
  const selected = new Date(dateStr);
  return (
    today.getFullYear() === selected.getFullYear() &&
    today.getMonth() === selected.getMonth() &&
    today.getDate() === selected.getDate()
  );
};
  useEffect(() => {
    if (selectedDate && selectedShift) {
      
      fetchShiftData(selectedDate, selectedShift,selectedMachine);
    }
     
    
  }, [selectedDate, selectedShift,selectedMachine,]);

useEffect(() => {
 
  let intervalId;

  const shouldPoll =
    selectedDate && selectedShift &&
    isToday(selectedDate) &&
    parseInt(selectedShift) === getCurrentShift();

  if (shouldPoll) {
    intervalId = setInterval(() => {
      fetchShiftData(selectedDate, selectedShift,selectedMachine);
    }, 60000); // 1 minute
  }

  return () => {
    if (intervalId) clearInterval(intervalId);
  };
}, [selectedDate, selectedShift,selectedMachine]);



  useEffect(() => {
    if (filteredData && filteredData.dateTimeList) {
      updateChartData();
    }
  }, [filteredData]);
console.log("filll",filteredData)
  const downSample = (array, step) => {
    return array.filter((_, index) => index % step === 0);
  };
  const updateChartData = () => {
    let dates = filteredData.dateTimeList;
    let goodData = filteredData.goodPartsList;
    let badData = filteredData.badPartsList;
   

    // Auto-sample if data is large
    const sampleStep = dates.length > 300 ? 5 : dates.length > 100 ? 3 : 1;
    dates = downSample(dates, sampleStep);
    goodData = downSample(goodData, sampleStep);
    badData = downSample(badData, sampleStep);

    setChartOptions({
      chart: {
        type: "area",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: true,
            zoom: true,
            pan: true,
            reset: true,
          },
        },
        zoom: { enabled: true },
        background: "transparent",
      },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 2 },
      colors: ["#4EB3D3", "#FF4D4D"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 90, 100],
        },
      },
      xaxis: {
        title: {
      text: "Time",
      style: { color: "#a6b0cf", fontWeight: 600,},
    },
        categories: dates,
        labels: {
          rotate: -45,
          style: { colors: "#a6b0cf" },
          show: dates.length <= 100,
        },
        tickAmount: 10,
      },
      yaxis: {
           min: 0,
  forceNiceScale: true,
        title: {
      text: "Parts per Minute",
      style: { color: "#a6b0cf", fontWeight: 600 },
    },
        labels: { style: { colors: "#a6b0cf" } },
      },
      legend: {
    position: "bottom",
    horizontalAlign: "right",
      },
      grid: { borderColor: "#45496a36" },
      tooltip: { theme: "dark" },
      markers: { size: dates.length > 100 ? 0 : 4 },
    });

    setChartSeries([
      { name: "Good Parts", data: goodData },
      { name: "Bad Parts", data: badData },
    ]);
  };
  const fetchShiftData = async (selectedDate, selectedShift,selectedMachine) => {
    try {
      setIsLoading(true);
      const shift = selectedShift || getCurrentShift();
      const response = await fetch(
        `https://api.hanoch.in/api/live-production-summary/?date=${selectedDate}&shift=${shift}&machine_id=${selectedMachine}`
      );
      if (!response.ok) {
        setFilteredData({ goodPartsList: [], badPartsList: [], dateTimeList: [] });
        updateChartData({ goodPartsList: [], badPartsList: [], dateTimeList: [] });
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      const part_multiple = data.part_number;
      const transformedData = {
        goodPartsList: data.data.map((item) => item.good_products * part_multiple),
        badPartsList: data.data.map((item) => item.bad_products * part_multiple),
        dateTimeList: data.data.map((item) => item.time),
      };
       console.log("tran",transformedData)
      setFilteredData(transformedData);
      updateChartData(transformedData);
    } catch (error) {
      console.error("Error fetching shift data:", error);
      // Clear chart on fetch failure
      setFilteredData({ goodPartsList: [], badPartsList: [], dateTimeList: [] });
      updateChartData({ goodPartsList: [], badPartsList: [], dateTimeList: [] });
    } finally {
      setIsLoading(false);
    }
  };
  
 
  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };

  return (
    <Col xl={12} style={{ marginBottom: "1.5rem" }}>
      <Card style={{ height: "100%" }}>
        <CardHeader>
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              <h5 className="card-title">Overview</h5>
            </div>
            <div className="flex-shrink-0">
              {/* Time range selector commented out */}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div>

             {/* Replace LineColumnArea with the new Chart component */}
              <Chart
                key={`${selectedDate}-${selectedShift}`}
                options={chartOptions}
                series={chartSeries}
                type="area"
                height={350}
              />
            </div>
            
          )} 
        </CardBody>
      </Card>
    </Col>
  );
};

export default OverView;
